import React, { useState, useEffect } from 'react';

import { Container, Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import Cards from './Cards';

import { useGetNodeNumber } from '../../hooks/token';
import tiers from '../../utils/tiers';
import { useGetAvgTax } from '../../hooks/bitfrostLibrary';

import styles from './style.module.css';

const HeadCard = ({nodes}) => {
  const [myNodesState, setMyNodesState] = useState(0);
  const { nodesData } = useSelector((state) => state.ui);
  const {data: avgTax, isLoading} = useGetAvgTax(nodes.data);
  
  const userTiers = Object.keys(tiers);
  const numberOfNodes = useGetNodeNumber();

  useEffect(() => {
    if (nodesData.length !== 0) {
      const nodes = nodesData.reduce((total, el) => {
        return (total += el.noded);
      }, 0);
      setMyNodesState(nodes);
    }
  }, [nodesData]);
  return (
    <Container
      className={`${styles.myNodeWrap} main_content_wrap`}
      maxWidth="lg"
      sx={{
        borderRadius: '10px',
        background: 'linear-gradient(92.91deg, rgba(19, 22, 30, 0.76) 1.78%, rgba(19, 22, 30, 0.62) 99.64%)',
        // padding: 4,
        marginBottom: 4,
      }}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        flexDirection={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
      >
        <Box
          // flex={1}
          className={styles.nodeLeft}
          display="flex"
          flexDirection={{ xs: 'row', sm: 'row', md: 'column' }}
          justifyContent={{
            xs: 'space-between',
            sm: 'space-between',
            md: 'normal',
          }}
        >
          <Box>
            <Typography className={styles.head1} component="div">
              My Nodes
            </Typography>
            <Typography component="div" className={styles.head2}>
              {numberOfNodes?.data ? numberOfNodes.data :  0}
            </Typography>
          </Box>
          <Box
            sx={{
              width: '296px',
              height: '0px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            }}
            display={{ xs: 'none', sm: 'none', md: 'block' }}
          ></Box>
          <Box
            marginTop={{ xs: 1, sm: 1, md: 2 }}
            display="flex"
            alignItems={{ xs: 'flex-end', sm: 'flex-end', md: 'center' }}
            flexDirection={{ xs: 'column', sm: 'column', md: 'row' }}
          >
            <Typography
              component="div"
              color={'white'}
              fontWeight={500}
              sx={{
                fontFamily: 'Kanit',
                color: 'rgba(255, 255, 255, 0.5)',
                lineHeight: '16px',
                fontSize: '12px',
              }}
            >
              Total Average Tax
            </Typography>
            <Typography
              component="div"
              sx={{
                background: 'linear-gradient(112.98deg, #FFF4D1 8.47%, #F5D28F 23.3%, #675537 91.31%);',
                fontFamily: 'Kanit',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                textFillColor: 'transparent',
                fontStyle: 'normal',
                WebkitTextFillColor: 'transparent',
                // lineHeight: "144px",
                fontSize: '16px',
                fontWeight: 500,
                marginLeft: '8px',
              }}
            >
             {!isLoading && avgTax ? <>{avgTax}%</>: <>0%</>}
            </Typography>
          </Box>
        </Box>
        <Box className={`${styles.mynodes_wrap} ${styles.nodeRight}`}>
          <Cards nodes={nodes?.data}/>
        </Box>
      </Box>
    </Container>
  );
};

export default HeadCard;
